module.exports = __webpack_public_path__ + "static/edu-65ee350c7875c9b422325141ac3f262b.gif";